import { Component, OnInit } from "@angular/core";
import { SeoService } from "src/app/core/services/seo.service";

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
    standalone: false
})
export class FooterComponent implements OnInit {
  title: string;

  constructor(private seoService: SeoService) {}

  ngOnInit() {
    this.title = this.seoService.getAppName();
  }
}
